<template src='./project-merging.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { EventBus } from '@/router/bus'
import { validationMixin } from '@/mixins/validation'
import Autocomplete from '@/components/misc/autocomplete/Autocomplete'

export default {
  components: {
    ContextPage,
    Autocomplete
  },
  mixins: [validationMixin],
  data () {
    return {
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      budgetUser: {
        id: ''
      },
      projectCode: this.$route.params.projectCode,
      updatedCode: this.$route.query.updatedCode,
      project: {},
      pageLoader: false,
      selectedOrganizationProject: { },
      organizationProjects: [],
      currentProject: { ProjectId: null, ProjectCode: null, OriginalProject: false },
      existingProject: { ProjectId: null, ProjectCode: null, OriginalProject: true }
    }
  },
  created () {
    this.setupPage()
  },
  mounted () {
    EventBus.$emit('reload-crumbs')
  },
  methods: {
    setupPage () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.projectDetailsGet + '/' + this.$route.params.projectCode)
        .then(
          response => {
            this.logConsole(response)
            this.project = response.data.payload
            this.currentProject.ProjectCode = this.project.code
            this.currentProject.ProjectId = this.project.id
            if (this.updatedCode) {
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$t('projects.updateProjectSuccessful'),
                errors: []
              })
            }
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    getProjectsBelongToOrganization (organizationId) {
      this.showLoader(true)
      this.$http.get(Vue.$config.api_root + '/' + Vue.$apiConfig.pagedProjectsGet + '/pending?perPage=10&page=1&merge=1&organizationId=' + organizationId)
        .then(
          response => {
            this.organizationProjects = response.data.payload.filter(project => project.code !== this.currentProject.ProjectCode).filter(project => !project.important).map(project => { return { code: project.code, value: project.id, name: project.nameFormJson } })
            this.logConsole(response)
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    handleChangeBudgetUserSelected (budgetUser) {
      if (budgetUser === null) {
        this.selectedOrganizationProject = {}
        this.existingProject.ProjectCode = null
        this.existingProject.ProjectId = null
      }
      if (!this.isObject(budgetUser)) return
      this.budgetUser.id = budgetUser.id
      this.getProjectsBelongToOrganization(this.budgetUser.id)
    },
    // validateBeforeProjectSubmit () {
    //   this.$v.$touch()
    //   if (this.$v.$invalid) {
    //     this.$nextTick(function () {
    //       document.body.scrollTop = 0
    //     })
    //     return
    //   }
    //   this.saveSettings()
    // },
    saveSettings () {
      this.showLoader(true)
      this.pageLoader = true
      var mergeRequestParm = {
        projects: [this.currentProject, this.existingProject]
      }
      if (!this.existingProject.ProjectCode) { mergeRequestParm.projects.pop() }

      this.$http.put(Vue.$apiConfig.projectMergePut, mergeRequestParm).then(
        response => {
          this.logConsole(response)
          const redirectProjectCode = response.body.payload.code
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('projects.updateProjectSuccessful'),
            errors: []
          })
          this.showLoader(false)
          this.pageLoader = false
          this.$router.push('/projects/' + redirectProjectCode + '/details')
        },
        error => {
          this.formatErrorResponse(error)
          this.showLoader(false)
          this.pageLoader = false
        })
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    },
    // Autocomplete
    autocompleteFilter (query) {
      console.log(parseInt(query))
      if (isNaN(parseInt(query))) {
        // we check for name
        return 'filter[name]'
      } else {
        // we check for id
        return 'filter[id]'
      }
    },
    prepareBudgetUsersResponseData (data) {
      return data.body.payload
    },
    handleChangeSelectedOrganizationProject () {
      this.existingProject.ProjectCode = this.selectedOrganizationProject.code
      this.existingProject.ProjectId = this.selectedOrganizationProject.value
    }
  }
}
</script>
